import React from 'react';
import PropTypes from 'prop-types';
import { AccordionItem } from '@tamagoshi/core/Accordion';
import Text from '@tamagoshi/core/Text';

import styles from './styles/index.module.scss';

const FooterAccordionItem = ({ id, title, subTitle, isVisible, children }) => (
  <AccordionItem
    title={
      <Text type="small" weight="semiBold" className={styles.title}>
        {title}
        <Text type="small" weight="regular" className={styles.subTitle}>
          {subTitle}
        </Text>
      </Text>
    }
    id={id}
  >
    {isVisible ? children : null}
  </AccordionItem>
);

FooterAccordionItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

FooterAccordionItem.displayName = 'FooterAccordionItem';

export default FooterAccordionItem;
